import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cpl-task',
  templateUrl: './cpl-task.component.html',
  styleUrl: './cpl-task.component.css'
})
export class CplTaskComponent {
  @Input() taskTitle: string;
  @Input() taskDescription: string;
  @Input() taskState: string;
  @Input() linkurl: string;
  @Input() linktext: string;
  @Input() taskType: string;
  @Input() canEdit: boolean = true;
  @Input() formTemplateId?: string;
  @Input() formTemplateVersion?: number;
  @Input() formTemplateName?: string;
  @Output() taskaction = new EventEmitter<any>();

  completeTask() {
    this.taskaction.emit({
      actionType: this.taskType
    });
  }
}